export interface Phase {
  readonly index: number;
  readonly name: string;
  readonly description: string;
}

export const PhaseUtils = {
  create({
    index,
    name,
    description,
  }: {
    index: number;
    name: string;
    description: string;
  }): Phase {
    return {
      index,
      name,
      description,
    };
  },

  fromMap(map: Record<string, any>): Phase {
    try {
      return PhaseUtils.create({
        index: map["index"] !== undefined ? Number(map["index"]) : -1,
        name: map["name"] ?? "",
        description: map["description"] ?? "",
      });
    } catch (e) {
      console.error(e);
      return PhaseUtils.empty();
    }
  },

  empty(): Phase {
    return PhaseUtils.create({ index: -1, name: "", description: "" });
  },

  toMap(phase: Phase): Record<string, any> {
    return {
      index: phase.index.toString(),
      name: phase.name,
      description: phase.description,
    };
  },

  toJson(phase: Phase): string {
    return JSON.stringify(PhaseUtils.toMap(phase));
  },

  copyWith(
    phase: Phase,
    { index, name, description }: { index?: number; name?: string; description?: string }
  ): Phase {
    return PhaseUtils.create({
      index: index ?? phase.index,
      name: name ?? phase.name,
      description: description ?? phase.description,
    });
  },

  toString(phase: Phase): string {
    return `Phase(index: ${phase.index}, name: ${phase.name}, description: ${phase.description})`;
  },

  equals(phase1: Phase, phase2: Phase): boolean {
    return (
      phase1.index === phase2.index &&
      phase1.name === phase2.name &&
      phase1.description === phase2.description
    );
  },
};
